import axios from 'axios';
import React, { useEffect, useState } from 'react'

export default function Cardheader() {
    const [team, setTeam] = useState([]);
    const [point, setPoint] = useState([]);
    const [statusteam, setStatusteam] = useState('')
    const urlapi = process.env.REACT_APP_BASE_URL;

    const getTeam = async () => {
        try {
            const response = await axios.get(urlapi + "Datateam?id_user=" + localStorage.getItem("id"));
            setTeam(response.data);
        } catch (error) {

        }
    }

    const getPoinrankteam = async () => {
        try {
            const response = await axios.get(
                urlapi + "Pointrankteam?id_user=" + localStorage.getItem("id")
            );
            setPoint(response.data);
        } catch (error) { }
    };

    const cekstatusteam = async () => {
        try {
            const response = await axios.get(
                urlapi + "Cekstatusteam?id=" + localStorage.getItem("id")
            );
            setStatusteam(response.data.status);
        } catch (error) { }
    };

    useEffect(() => {
        getTeam();
        getPoinrankteam();
        cekstatusteam();
    }, [])

    const labels = [
        { label: 'Play', value: point == false ? 0 : point.play },
        { label: 'Win', value: point == false ? 0 : point.win },
        { label: 'Draw', value: point == false ? 0 : point.draw },
        { label: 'Lost', value: point == false ? 0 : point.lost },
        { label: 'Point', value: point == false ? 0 : point.point, primary: true },
        { label: 'Status', value: statusteam == 1 ? 'Aktif' : 'Nonaktif', primary: statusteam != 1 },
    ];

    return (
        <div>
            <div className="trt-header-card">
                <div className="trt-team-badge">
                    <img
                        src={team == '' ? '/img/club.png' : `${team.logo_team}`}
                        className="trt-team-logo"
                        alt="logo team"
                    />
                    {team != '' ? (
                        <>
                            <div className="trt-team-name">{team.nama_team}</div>
                            <div
                                className="trt-team-status"
                                style={{ color: statusteam == 1 ? '#1e8e3e' : '#8a8f9e' }}
                            >
                                {statusteam == 1 ? '● Aktif' : '● Belum aktif'}
                            </div>
                        </>
                    ) : (
                        <div className="trt-team-status" style={{ color: '#8a8f9e' }}>
                            ● Belum daftar
                        </div>
                    )}
                </div>

                <div className="trt-stat-grid">
                    {labels.map((s, i) => (
                        <div key={i} className={`trt-stat-card ${s.primary ? 'primary' : ''}`}>
                            <div className="trt-stat-value">{s.value}</div>
                            <div className="trt-stat-label">{s.label}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
